/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EnrichedFieldInfo } from './enrichedFieldInfo';


export interface EnrichedAvailableFieldsResponse { 
    fields?: Array<EnrichedFieldInfo>;
    serial_number?: string;
    fetched_at?: string;
}

